import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineBadge } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";

const Id = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  disabled,
  paymentConditions = {},
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const {
    requiresSubscriberPaysButDifferentReceiver = false,
    requiresThirdPartyPayer = false,
    requiresPayerCin = false,
    requiresBothThirdParty = false,
  } = paymentConditions;

  // Determine which CINs are required based on payment conditions
  // Adherent CIN required when: subscriber pays but different receiver, third-party payer, or both third-party
  const showAdherentCin =
    requiresSubscriberPaysButDifferentReceiver ||
    requiresThirdPartyPayer ||
    requiresBothThirdParty;

  // Payer CIN required when: third-party payer is a particular person (not an organization)
  const showPayerCin = requiresPayerCin;
  // If no special conditions, always show adherent CIN
  const showDefaultAdherentCin = !showAdherentCin;

  return (
    <div className="subscription-form--wrapper">
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.PROOF.ID.TITLE}
        subtitle={SUBSCRIPTION.FORM.PROOF.ID.SUBTITLE}
      >
        {/* Adherent CIN - Always shown (required based on conditions) */}
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={SUBSCRIPTION.FORM.PROOF.ADHERENT}
                icon={<MdOutlineBadge size={16} />}
                required={showAdherentCin || showDefaultAdherentCin}
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue("proof.cin", fileList);
                  setPercent({
                    ...values,
                    proof: { ...values.proof, cin: fileList },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.cin", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>

        {/* Payer CIN - Shown when third-party payer or both third-party */}
        {showPayerCin && (
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <Label
                  label={
                    SUBSCRIPTION.FORM.PROOF.PAYER_CIN?.LABEL ||
                    "Pièce d'identité du payeur"
                  }
                  icon={<MdOutlineBadge size={16} />}
                  required
                />
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                  onUpload={(fileList) => {
                    setFieldValue("proof.payerCin", fileList);
                    setPercent({
                      ...values,
                      proof: { ...values.proof, payerCin: fileList },
                    });
                  }}
                  onFileRemove={onFileRemove}
                  fileList={get(values, "proof.payerCin", [])}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default Id;
